import { createServerFn } from "@tanstack/react-start";
import { fetchTruckStatsReport } from "@/lib/reports.server";

export const getTruckStatsReport = createServerFn({ method: "GET" }).handler(
  fetchTruckStatsReport,
);
